import { newProjectId } from '~/constant'

export const projectsRoot = '/projects'

export const AppRoutes = {
  Projects: projectsRoot,
  NewProject: `${projectsRoot}/${newProjectId}`,
}
